import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

export const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiListItem-root': {

        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}));